export const MAX_REACHABLE_LEVEL = 8;
export const NOVICE_LEVEL = 3;
export const INDEPENDENT_LEVEL = 5;
export const ADVANCED_LEVEL = 7;
